import { render } from "./img-placeholder.vue?vue&type=template&id=1d41a786&ts=true"
import script from "./img-placeholder.vue?vue&type=script&lang=ts"
export * from "./img-placeholder.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__